import { create } from "zustand";

export const initialModalValue = {
	pageChange: false,
	componentType: "",
	componentName: "",
	productVersion: "",
};
type Store = {
	modalData: any;
	setModalData: (value: any) => void;
	resetModalData: () => void;
};
export const useCreateModalStore = create<Store>()((set) => ({
	modalData: initialModalValue,
	setModalData: (value: any) => set(() => ({ modalData: value })),
	resetModalData: () => set(() => ({ modalData: initialModalValue })),
}));
